function Contact() {
  return (
    <section>
      <h2>Contact</h2>
      <p>This is a simple contact route for now.</p>
    </section>
  );
}

export default Contact;
